"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetUserTermsAndConditionsStatus = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.SetUserTermsAndConditionsStatus = (0, graphql_tag_1.default) `
  mutation SetUserTermsAndConditionsStatus($hasAccepted: Boolean!) {
    setUserTermsAndConditionsStatus(hasAccepted: $hasAccepted) {
      id
    }
  }
`;
//# sourceMappingURL=set-user-terms-and-conditions-status.js.map